import { AxiosResponse } from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import Loader from "../../../components/loader";
import { APIResponseEntity } from "../../../interface/api-responce";
import { APIExportDraftWOs, APISingleExportDraftWO } from "../../../service/api-service";
import { downloadCsvFile } from "../../../service/shared.service";
import { toastOptObj } from "../../../utils/constants";
import { IsNullOrUndefined, IsStringNullEmptyOrUndefined } from "../../../utils/null-check";

function ExportDraftWOs({ type, orderReferenceNumber }: { type: "bulkAction" | "singleExport"; orderReferenceNumber: string | null }): JSX.Element {

    const [isLoading, setIsLoading] = useState(false);

    const exportTransaction = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse | null = (type === "bulkAction")
            ? await APIExportDraftWOs()
            : orderReferenceNumber && !IsNullOrUndefined(orderReferenceNumber)
                ? await APISingleExportDraftWO(orderReferenceNumber)
                : null;
        setIsLoading(false);

        if (!resp || (resp && (resp.status !== 200 || !resp.data))) { return; }

        const apiRespPayload: APIResponseEntity = resp.data;

        if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
            toast.error(apiRespPayload.message || apiRespPayload.errorMsg, { ...toastOptObj });
            setIsLoading(false);
            return;
        }

        const exportData: { xlsxUrl: string } = apiRespPayload.data;

        if (IsStringNullEmptyOrUndefined(exportData.xlsxUrl)) { return; }

        const fileName: string | undefined = exportData.xlsxUrl.split("/").pop();
        if (!fileName || IsStringNullEmptyOrUndefined(fileName)) { return; }

        if (fileName && !IsStringNullEmptyOrUndefined(fileName)) {
            await downloadCsvFile(exportData.xlsxUrl, fileName);
        }
    };

    return (
        <>
            <Loader isLoading={isLoading} />

            <button type="button" className="btn btn-success" onClick={exportTransaction}>
                {type === "bulkAction" ? "Export Draft WO" : "Export Draft WOs"}
            </button>
        </>
    )
}

export default ExportDraftWOs;